
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cannabis-store/[slug]/reviews",
      function () {
        return require("private-next-pages/cannabis-store/[slug]/reviews.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cannabis-store/[slug]/reviews"])
      });
    }
  